import Splide from '@splidejs/splide';
import '@splidejs/splide/dist/css/themes/splide-default.min.css';

export function blockPartnersSliderScript() {
    document.addEventListener('DOMContentLoaded', function () {
        const blocksSmallNew = document.querySelectorAll('.partners__sliders');


        blocksSmallNew.forEach(block => {
            let smallIconNew = new Splide(block, {
                type  : 'loop',
                rewind: false,
                autoplay: true,
                perPage: 6,
                gap: 40,
                perMove: 1,
                pagination:false,
                arrows: false,
                interval: 1000,
                speed: 4000,
                breakpoints: {
                    1920: {perPage: 3.9},
                    1400: { perPage: 3.2 },
                },
            });

            smallIconNew.mount()

        });
    })
}